import React from "react";
import { MARQUEE } from "@/constants/testIds";

const words = [
  { en: "Kutumb", dv: "कुटुम्ब" },
  { en: "Family", dv: "परिवार" },
  { en: "Vamsham", dv: "வம்சம்" },
  { en: "Kula", dv: "कुल" },
  { en: "Roots", dv: "मूल" },
  { en: "Memory", dv: "स्मृति" },
  { en: "Home", dv: "घर" },
  { en: "Legacy", dv: "विरासत" },
];

export default function Marquee() {
  const list = [...words, ...words];
  return (
    <section
      data-testid={MARQUEE.root}
      className="relative border-y border-ivory-300 bg-ivory-100/60 overflow-hidden py-8"
    >
      <div className="flex whitespace-nowrap animate-marquee-x will-change-transform">
        {list.map((w, i) => (
          <div key={i} className="flex items-center px-10">
            <span className="font-serif italic text-ink text-4xl sm:text-5xl md:text-6xl tracking-tight">
              {w.en}
            </span>
            <span className="mx-6 text-saffron text-3xl">✦</span>
            <span className="font-devanagari text-ink text-4xl sm:text-5xl md:text-6xl">
              {w.dv}
            </span>
            <span className="mx-6 text-tulsi/50 text-3xl">/</span>
          </div>
        ))}
      </div>
    </section>
  );
}
